"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logCreativeId = exports.logClick = exports.logInview = exports.logHorseshoe = void 0;
var analytics_1 = __importDefault(require("@finn-no/analytics"));
var event_data_1 = require("./event-data");
var finn_1 = require("./finn");
var lazy_1 = require("./lazy");
var creativeIds = {};
var bannerObjs = {};
var hasHorseshoe = false;
function logHorseshoe() {
    hasHorseshoe = true;
}
exports.logHorseshoe = logHorseshoe;
function track(type, tagId, element, adObj, additionalContext) {
    var banner = adObj || bannerObjs[tagId];
    var creativeId = (adObj && adObj.creativeId) || creativeIds[tagId];
    analytics_1.default.getApi(function (api) {
        var context = api.prepareContext().context;
        if (context) {
            var vertical = context.vertical;
            var eventData = event_data_1.getEcEventData(tagId, element, vertical, creativeId, banner, hasHorseshoe);
            var trackingConfig = {
                ecType: 'TRACKING',
                ecCategory: type,
                eventData: eventData,
            };
            if (additionalContext) {
                analytics_1.default.trackEvent(__assign(__assign({}, trackingConfig), additionalContext));
            }
            else {
                // @ts-ignore analyticsName is missing
                analytics_1.default.trackEvent(trackingConfig);
            }
        }
    });
}
function logInview(tagId, adObj, additionalContext) {
    logBannerObj(tagId, adObj);
    logCreativeId(tagId, adObj.creativeId);
    var element = document.getElementById(tagId);
    if (element) {
        track('inview', tagId, element, adObj, additionalContext);
        observeBanner(element);
    }
}
exports.logInview = logInview;
function logInscreen(element) {
    var tagId = element.id;
    if (tagId) {
        track('inscreen', tagId, element);
    }
}
function logClick(tagId, adObj, additionalContext) {
    if (tagId) {
        track('click', tagId, undefined, adObj, additionalContext);
    }
}
exports.logClick = logClick;
function logCreativeId(tagId, creativeId) {
    creativeIds[tagId] = creativeId;
    finn_1.updateFinnGlobalVar(creativeIds);
}
exports.logCreativeId = logCreativeId;
function logBannerObj(tagId, adObj) {
    bannerObjs[tagId] = adObj;
}
function observeBanner(ele) {
    lazy_1.inscreen(ele, logInscreen, {
        timeout: 1000,
    });
}
